/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { getDapps } from '../../../axiosCalls/admin.axios';
import config from '../../../config/config'
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Table,
    Row,
    Col,
    Button
} from "reactstrap";

function DappsList() {

    const [list, setlist] = useState([]);
    console.log("statelist", list);
    let history = useHistory()
    // var user = JSON.parse(localStorage.getItem('reg'));
    // console.log("dfggggggggg",user)

    useEffect(() => {
        get();
    }, [])
    console.log("config",config);

    const get = async () => {
        var gettingCurrency = await getDapps();
        console.log("gettingCurrency", gettingCurrency);
        setlist(gettingCurrency?.data ?? [])
    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h1">Dapps List</CardTitle>
                                <Link to="/admin/AddDapps">Add</Link>
                            </CardHeader>

                            <CardBody>
                                {/* {console.log('liastttt', list)} */}


                                <Table className="tablesorter" responsive>
                                    <thead className="text-primary">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Title</th>
                                            <th>Description</th>
                                            <th>Url</th>
                                            <th>CategoryName</th>
                                            <th>Appimage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list?.map((res, index) => {
                                            return (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{res.title}</td>
                                                    <td>{res.description}</td>
                                                    <td>{res.url}</td>
                                                    <td>{res.categoryName}</td>
                                                    <td><img height={50} width={50} src={`${config.image_Url+res.appimage}`}></img></td>
                                                    {/* <Button onClick={() => {
                                                        // history.push('/admin/language-edit', { state: res })
                                                    }}>edit</Button> */}
                                                    <td className="text-center"></td>
                                                </tr>)
                                        })}

                                    </tbody>
                                </Table>

                            </CardBody>
                        </Card>
                    </Col>

                </Row>
            </div>
        </>
    );
}

export default DappsList;
